export enum ExchangeOption {
  Nyse = 'NYSE',
  Nasdaq = 'Nasdaq',
  NyseAmerican = 'NYSE American',
  AIM = 'AIM',
  ShanghaiStockExchange = 'Shanghai Stock Exchange',
  ShanghaiTech = 'Shanghai Tech',
  ShenzhenStockExchange = 'Shenzhen Stock Exchange',
}
